import { TFunction } from 'i18next';
import { SiteArea } from 'graphql-common';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import { TooltipProps } from '@lib/components/Tooltip/Tooltip';
import { getAuthorizationReason } from '@lib/utils/authorizationReason';

type ActionsMenuArgs = {
  onViewHandler: (area?: SiteArea) => void;
  onEditHandler: (area?: SiteArea) => void;
  onDelete: (area?: SiteArea) => void;
  t: TFunction<'translation', undefined>;
  isViewOnly: boolean;
};

export default function getSiteAreasActionsMenu({
  onViewHandler,
  onEditHandler,
  onDelete,
  t,
  isViewOnly,
}: ActionsMenuArgs): NavItem<SiteArea>[] {
  return [
    {
      id: 'view-action',
      title: t('view'),
      onClick: (item?: SiteArea) => onViewHandler(item),
      leftIcon: Icons.view,
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'edit-action',
      title: t('edit'),
      onClick: (item?: SiteArea) => onEditHandler(item),
      leftIcon: Icons.edit,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => !isViewOnly,
    },
    {
      id: 'delete-action',
      title: t('delete'),
      onClick: (item?: SiteArea) => onDelete(item),
      leftIcon: Icons.delete,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => !isViewOnly,
      // `canDestroy` is only selected on the list query, so default to enabled
      // wherever it was not asked for rather than disabling every row.
      predictorFnDisable: (item?: SiteArea) =>
        item?.canDestroy?.value === false,
      predictorFnDisableTooltipProps: (item?: SiteArea) =>
        item?.canDestroy?.value === false
          ? ({
              body:
                getAuthorizationReason(item.canDestroy) ||
                t('site-area-disabled-destroy-desc'),
              placement: 'left',
            } as Omit<TooltipProps, 'children'>)
          : undefined,
    },
  ];
}
